// Constants for CreateTicket module

// Slot types enum - defines the types of slots that can be booked
export const SLOT_TYPES = {
    CUSTOMER_COMPLAINT: 'CUSTOMER_COMPLAINT',
    MEDICAL_ESCALATION: 'MEDICAL_ESCALATION'
};

export const REGIONAL_LANGUAGES = ['TAMIL', 'TELUGU', 'KANNADA', 'ENGLISH'];